import { call, takeLatest, put } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchExperimentsTableData } from 'api/ExperimentsAPI';
import { Saga } from 'custom-types/saga';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import {
  ExperimentsAction,
  ExperimentsTableQuery,
  ExperimentsTableData,
} from 'modules/experiments/types';
import { getExperimentsTranslations } from 'modules/experiments/utils';
import * as actions from 'modules/experiments/ducks/actions';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';

type FetchExperimentsTableDataResponse = {
  data: {
    experiments: ExperimentsTableData;
  };
};

export function* fetchExperimentsTableDataSaga({
  queryData,
}: ExperimentsAction<{
  queryData: ExperimentsTableQuery;
}>): Saga<ExperimentsAction<Record<string, unknown>, ExperimentsTableData>> {
  try {
    const {
      data: { experiments },
    }: FetchExperimentsTableDataResponse = yield call(fetchExperimentsTableData, queryData);

    yield put(actions.fetchExperimentsTableDataResponse(experiments));
  } catch (error) {
    yield put(actions.fetchExperimentsTableDataError());

    const errorMessage = yield call(
      getExperimentsTranslations,
      'errorMessage.fetchExperimentsTableData',
    );
    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          errorMessage,
          source: 'fetchExperimentsTableDataSaga',
          error,
          additional: queryData,
        }),
      ) as any,
    );
  }
}

addToRootSaga([takeLatest(ActionTypes.FETCH_TABLE_DATA_REQUEST, fetchExperimentsTableDataSaga)]);
